import React from 'react'
import Markdown from 'react-markdown'
import Loader from 'react-loader-spinner'
import { useProgramContext } from 'providers/programProvider'

const CustomLinks = ({ location, options }) => {
  const [state] = useProgramContext()
  const links = state?.links?.filter(link => link.location === location)
  return (
    <>
      {!state?.links?.length ? (
        <Loader type="ThreeDots" height={30} width={30} color="#bdbdbd" />
      ) : (
        links?.map(({ template }, ix) => {
          const linkTarget = template.includes("http") ? "_blank" : "_self";
          return (
            <Markdown
              source={template}
              key={`link-${template}-${ix}`}
              linkTarget={linkTarget}
              {...options}
            />
          );
        })
      )}
    </>
  )
}

export default CustomLinks
